/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as IntegrationsCallbackImport } from './routes/integrations-callback'
import { Route as ImpersonateImport } from './routes/impersonate'
import { Route as LogoutRouteImport } from './routes/logout/route'
import { Route as LoginRouteImport } from './routes/login/route'
import { Route as DesktopRouteImport } from './routes/desktop/route'
import { Route as AppRouteImport } from './routes/_app/route'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as SummaryCallIdImport } from './routes/summary.$callId'
import { Route as ShareShareTokenImport } from './routes/share.$shareToken'
import { Route as OauthConsentImport } from './routes/oauth/consent'
import { Route as LoginOtpCodeImport } from './routes/login/otp-code'
import { Route as LoginOnboardingImport } from './routes/login/onboarding'
import { Route as JobberConnectedImport } from './routes/jobber/connected'
import { Route as DesktopPipCallImport } from './routes/desktop/pip-call'
import { Route as DesktopIncomingCallImport } from './routes/desktop/incoming-call'
import { Route as AppPowerDialerImport } from './routes/_app/power-dialer'
import { Route as AppContactsImport } from './routes/_app/contacts'
import { Route as AppCompaniesImport } from './routes/_app/companies'
import { Route as AppCallsImport } from './routes/_app/calls'
import { Route as AppAnalyticsImport } from './routes/_app/analytics'
import { Route as onboardingInviteTeamImport } from './routes/(onboarding)/invite-team'
import { Route as onboardingChooseNumberImport } from './routes/(onboarding)/choose-number'
import { Route as AppSettingsRouteImport } from './routes/_app/settings/route'
import { Route as AppInternalRouteImport } from './routes/_app/internal/route'
import { Route as AppSettingsIndexImport } from './routes/_app/settings/index'
import { Route as AppPowerDialerIndexImport } from './routes/_app/power-dialer.index'
import { Route as AppSettingsWebhooksImport } from './routes/_app/settings/webhooks'
import { Route as AppSettingsUsageImport } from './routes/_app/settings/usage'
import { Route as AppSettingsTemplatesImport } from './routes/_app/settings/templates'
import { Route as AppSettingsTeamImport } from './routes/_app/settings/team'
import { Route as AppSettingsProfileImport } from './routes/_app/settings/profile'
import { Route as AppSettingsApiImport } from './routes/_app/settings/api'
import { Route as AppInternalUsersImport } from './routes/_app/internal/users'
import { Route as AppInternalOauthImport } from './routes/_app/internal/oauth'
import { Route as AppContactContactIdImport } from './routes/_app/contact.$contactId'
import { Route as AppCallNumberImport } from './routes/_app/call.$number'
import { Route as AppCallFlowNumberImport } from './routes/_app/call-flow.$number'
import { Route as AppSettingsNumbersRouteImport } from './routes/_app/settings/numbers/route'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations/route'
import { Route as AppSettingsComplianceRouteImport } from './routes/_app/settings/compliance/route'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing/route'
import { Route as AppSettingsNumbersIndexImport } from './routes/_app/settings/numbers/index'
import { Route as AppSettingsIntegrationsIndexImport } from './routes/_app/settings/integrations/index'
import { Route as AppSettingsComplianceIndexImport } from './routes/_app/settings/compliance/index'
import { Route as AppSettingsCallTagsIndexImport } from './routes/_app/settings/call-tags/index'
import { Route as AppSettingsBillingIndexImport } from './routes/_app/settings/billing/index'
import { Route as AppSettingsNumbersNumberImport } from './routes/_app/settings/numbers/$number'
import { Route as AppSettingsIntegrationsClaudeConnectorImport } from './routes/_app/settings/integrations/claude-connector'
import { Route as AppSettingsIntegrationsIntegrationNameImport } from './routes/_app/settings/integrations/$integrationName'
import { Route as AppSettingsComplianceCampaignImport } from './routes/_app/settings/compliance/campaign'
import { Route as AppSettingsComplianceBrandImport } from './routes/_app/settings/compliance/brand'
import { Route as AppPowerDialerSessionSessionIdImport } from './routes/_app/power-dialer.session.$sessionId'

// Create/Update Routes

const IntegrationsCallbackRoute = IntegrationsCallbackImport.update({
  id: '/integrations-callback',
  path: '/integrations-callback',
  getParentRoute: () => rootRoute,
} as any)

const ImpersonateRoute = ImpersonateImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRouteRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRouteRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const DesktopRouteRoute = DesktopRouteImport.update({
  id: '/desktop',
  path: '/desktop',
  getParentRoute: () => rootRoute,
} as any)

const AppRouteRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRouteRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)

const SummaryCallIdRoute = SummaryCallIdImport.update({
  id: '/summary/$callId',
  path: '/summary/$callId',
  getParentRoute: () => rootRoute,
} as any)

const ShareShareTokenRoute = ShareShareTokenImport.update({
  id: '/share/$shareToken',
  path: '/share/$shareToken',
  getParentRoute: () => rootRoute,
} as any)

const OauthConsentRoute = OauthConsentImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRoute,
} as any)

const LoginOtpCodeRoute = LoginOtpCodeImport.update({
  id: '/otp-code',
  path: '/otp-code',
  getParentRoute: () => LoginRouteRoute,
} as any)

const LoginOnboardingRoute = LoginOnboardingImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => LoginRouteRoute,
} as any)

const JobberConnectedRoute = JobberConnectedImport.update({
  id: '/jobber/connected',
  path: '/jobber/connected',
  getParentRoute: () => rootRoute,
} as any)

const DesktopPipCallRoute = DesktopPipCallImport.update({
  id: '/pip-call',
  path: '/pip-call',
  getParentRoute: () => DesktopRouteRoute,
} as any)

const DesktopIncomingCallRoute = DesktopIncomingCallImport.update({
  id: '/incoming-call',
  path: '/incoming-call',
  getParentRoute: () => DesktopRouteRoute,
} as any)

const AppPowerDialerRoute = AppPowerDialerImport.update({
  id: '/power-dialer',
  path: '/power-dialer',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppContactsRoute = AppContactsImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCompaniesRoute = AppCompaniesImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCallsRoute = AppCallsImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppAnalyticsRoute = AppAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRouteRoute,
} as any)

const onboardingInviteTeamRoute = onboardingInviteTeamImport.update({
  id: '/(onboarding)/invite-team',
  path: '/invite-team',
  getParentRoute: () => rootRoute,
} as any)

const onboardingChooseNumberRoute = onboardingChooseNumberImport.update({
  id: '/(onboarding)/choose-number',
  path: '/choose-number',
  getParentRoute: () => rootRoute,
} as any)

const AppSettingsRouteRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppInternalRouteRoute = AppInternalRouteImport.update({
  id: '/internal',
  path: '/internal',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSettingsIndexRoute = AppSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppPowerDialerIndexRoute = AppPowerDialerIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPowerDialerRoute,
} as any)

const AppSettingsWebhooksRoute = AppSettingsWebhooksImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsUsageRoute = AppSettingsUsageImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsTemplatesRoute = AppSettingsTemplatesImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsTeamRoute = AppSettingsTeamImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsProfileRoute = AppSettingsProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsApiRoute = AppSettingsApiImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppInternalUsersRoute = AppInternalUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppInternalRouteRoute,
} as any)

const AppInternalOauthRoute = AppInternalOauthImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => AppInternalRouteRoute,
} as any)

const AppContactContactIdRoute = AppContactContactIdImport.update({
  id: '/contact/$contactId',
  path: '/contact/$contactId',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCallNumberRoute = AppCallNumberImport.update({
  id: '/call/$number',
  path: '/call/$number',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppCallFlowNumberRoute = AppCallFlowNumberImport.update({
  id: '/call-flow/$number',
  path: '/call-flow/$number',
  getParentRoute: () => AppRouteRoute,
} as any)

const AppSettingsNumbersRouteRoute = AppSettingsNumbersRouteImport.update({
  id: '/numbers',
  path: '/numbers',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsIntegrationsRouteRoute =
  AppSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)

const AppSettingsComplianceRouteRoute = AppSettingsComplianceRouteImport.update(
  {
    id: '/compliance',
    path: '/compliance',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any,
)

const AppSettingsBillingRouteRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsNumbersIndexRoute = AppSettingsNumbersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsNumbersRouteRoute,
} as any)

const AppSettingsIntegrationsIndexRoute =
  AppSettingsIntegrationsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsIntegrationsRouteRoute,
  } as any)

const AppSettingsComplianceIndexRoute = AppSettingsComplianceIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsComplianceRouteRoute,
  } as any,
)

const AppSettingsCallTagsIndexRoute = AppSettingsCallTagsIndexImport.update({
  id: '/call-tags/',
  path: '/call-tags/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)

const AppSettingsBillingIndexRoute = AppSettingsBillingIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsBillingRouteRoute,
} as any)

const AppSettingsNumbersNumberRoute = AppSettingsNumbersNumberImport.update({
  id: '/$number',
  path: '/$number',
  getParentRoute: () => AppSettingsNumbersRouteRoute,
} as any)

const AppSettingsIntegrationsClaudeConnectorRoute =
  AppSettingsIntegrationsClaudeConnectorImport.update({
    id: '/claude-connector',
    path: '/claude-connector',
    getParentRoute: () => AppSettingsIntegrationsRouteRoute,
  } as any)

const AppSettingsIntegrationsIntegrationNameRoute =
  AppSettingsIntegrationsIntegrationNameImport.update({
    id: '/$integrationName',
    path: '/$integrationName',
    getParentRoute: () => AppSettingsIntegrationsRouteRoute,
  } as any)

const AppSettingsComplianceCampaignRoute =
  AppSettingsComplianceCampaignImport.update({
    id: '/campaign',
    path: '/campaign',
    getParentRoute: () => AppSettingsComplianceRouteRoute,
  } as any)

const AppSettingsComplianceBrandRoute = AppSettingsComplianceBrandImport.update(
  {
    id: '/brand',
    path: '/brand',
    getParentRoute: () => AppSettingsComplianceRouteRoute,
  } as any,
)

const AppPowerDialerSessionSessionIdRoute =
  AppPowerDialerSessionSessionIdImport.update({
    id: '/session/$sessionId',
    path: '/session/$sessionId',
    getParentRoute: () => AppPowerDialerRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRoute
    }
    '/desktop': {
      id: '/desktop'
      path: '/desktop'
      fullPath: '/desktop'
      preLoaderRoute: typeof DesktopRouteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRoute
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateImport
      parentRoute: typeof rootRoute
    }
    '/integrations-callback': {
      id: '/integrations-callback'
      path: '/integrations-callback'
      fullPath: '/integrations-callback'
      preLoaderRoute: typeof IntegrationsCallbackImport
      parentRoute: typeof rootRoute
    }
    '/_app/internal': {
      id: '/_app/internal'
      path: '/internal'
      fullPath: '/internal'
      preLoaderRoute: typeof AppInternalRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteImport
    }
    '/(onboarding)/choose-number': {
      id: '/(onboarding)/choose-number'
      path: '/choose-number'
      fullPath: '/choose-number'
      preLoaderRoute: typeof onboardingChooseNumberImport
      parentRoute: typeof rootRoute
    }
    '/(onboarding)/invite-team': {
      id: '/(onboarding)/invite-team'
      path: '/invite-team'
      fullPath: '/invite-team'
      preLoaderRoute: typeof onboardingInviteTeamImport
      parentRoute: typeof rootRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/calls': {
      id: '/_app/calls'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof AppCallsImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/companies': {
      id: '/_app/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AppCompaniesImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/power-dialer': {
      id: '/_app/power-dialer'
      path: '/power-dialer'
      fullPath: '/power-dialer'
      preLoaderRoute: typeof AppPowerDialerImport
      parentRoute: typeof AppRouteImport
    }
    '/desktop/incoming-call': {
      id: '/desktop/incoming-call'
      path: '/incoming-call'
      fullPath: '/desktop/incoming-call'
      preLoaderRoute: typeof DesktopIncomingCallImport
      parentRoute: typeof DesktopRouteImport
    }
    '/desktop/pip-call': {
      id: '/desktop/pip-call'
      path: '/pip-call'
      fullPath: '/desktop/pip-call'
      preLoaderRoute: typeof DesktopPipCallImport
      parentRoute: typeof DesktopRouteImport
    }
    '/jobber/connected': {
      id: '/jobber/connected'
      path: '/jobber/connected'
      fullPath: '/jobber/connected'
      preLoaderRoute: typeof JobberConnectedImport
      parentRoute: typeof rootRoute
    }
    '/login/onboarding': {
      id: '/login/onboarding'
      path: '/onboarding'
      fullPath: '/login/onboarding'
      preLoaderRoute: typeof LoginOnboardingImport
      parentRoute: typeof LoginRouteImport
    }
    '/login/otp-code': {
      id: '/login/otp-code'
      path: '/otp-code'
      fullPath: '/login/otp-code'
      preLoaderRoute: typeof LoginOtpCodeImport
      parentRoute: typeof LoginRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentImport
      parentRoute: typeof rootRoute
    }
    '/share/$shareToken': {
      id: '/share/$shareToken'
      path: '/share/$shareToken'
      fullPath: '/share/$shareToken'
      preLoaderRoute: typeof ShareShareTokenImport
      parentRoute: typeof rootRoute
    }
    '/summary/$callId': {
      id: '/summary/$callId'
      path: '/summary/$callId'
      fullPath: '/summary/$callId'
      preLoaderRoute: typeof SummaryCallIdImport
      parentRoute: typeof rootRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof LoginRouteImport
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/compliance': {
      id: '/_app/settings/compliance'
      path: '/compliance'
      fullPath: '/settings/compliance'
      preLoaderRoute: typeof AppSettingsComplianceRouteImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/numbers': {
      id: '/_app/settings/numbers'
      path: '/numbers'
      fullPath: '/settings/numbers'
      preLoaderRoute: typeof AppSettingsNumbersRouteImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/call-flow/$number': {
      id: '/_app/call-flow/$number'
      path: '/call-flow/$number'
      fullPath: '/call-flow/$number'
      preLoaderRoute: typeof AppCallFlowNumberImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/call/$number': {
      id: '/_app/call/$number'
      path: '/call/$number'
      fullPath: '/call/$number'
      preLoaderRoute: typeof AppCallNumberImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/contact/$contactId': {
      id: '/_app/contact/$contactId'
      path: '/contact/$contactId'
      fullPath: '/contact/$contactId'
      preLoaderRoute: typeof AppContactContactIdImport
      parentRoute: typeof AppRouteImport
    }
    '/_app/internal/oauth': {
      id: '/_app/internal/oauth'
      path: '/oauth'
      fullPath: '/internal/oauth'
      preLoaderRoute: typeof AppInternalOauthImport
      parentRoute: typeof AppInternalRouteImport
    }
    '/_app/internal/users': {
      id: '/_app/internal/users'
      path: '/users'
      fullPath: '/internal/users'
      preLoaderRoute: typeof AppInternalUsersImport
      parentRoute: typeof AppInternalRouteImport
    }
    '/_app/settings/api': {
      id: '/_app/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof AppSettingsApiImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/templates': {
      id: '/_app/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof AppSettingsTemplatesImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/usage': {
      id: '/_app/settings/usage'
      path: '/usage'
      fullPath: '/settings/usage'
      preLoaderRoute: typeof AppSettingsUsageImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/webhooks': {
      id: '/_app/settings/webhooks'
      path: '/webhooks'
      fullPath: '/settings/webhooks'
      preLoaderRoute: typeof AppSettingsWebhooksImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/power-dialer/': {
      id: '/_app/power-dialer/'
      path: '/'
      fullPath: '/power-dialer/'
      preLoaderRoute: typeof AppPowerDialerIndexImport
      parentRoute: typeof AppPowerDialerImport
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/power-dialer/session/$sessionId': {
      id: '/_app/power-dialer/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/power-dialer/session/$sessionId'
      preLoaderRoute: typeof AppPowerDialerSessionSessionIdImport
      parentRoute: typeof AppPowerDialerImport
    }
    '/_app/settings/compliance/brand': {
      id: '/_app/settings/compliance/brand'
      path: '/brand'
      fullPath: '/settings/compliance/brand'
      preLoaderRoute: typeof AppSettingsComplianceBrandImport
      parentRoute: typeof AppSettingsComplianceRouteImport
    }
    '/_app/settings/compliance/campaign': {
      id: '/_app/settings/compliance/campaign'
      path: '/campaign'
      fullPath: '/settings/compliance/campaign'
      preLoaderRoute: typeof AppSettingsComplianceCampaignImport
      parentRoute: typeof AppSettingsComplianceRouteImport
    }
    '/_app/settings/integrations/$integrationName': {
      id: '/_app/settings/integrations/$integrationName'
      path: '/$integrationName'
      fullPath: '/settings/integrations/$integrationName'
      preLoaderRoute: typeof AppSettingsIntegrationsIntegrationNameImport
      parentRoute: typeof AppSettingsIntegrationsRouteImport
    }
    '/_app/settings/integrations/claude-connector': {
      id: '/_app/settings/integrations/claude-connector'
      path: '/claude-connector'
      fullPath: '/settings/integrations/claude-connector'
      preLoaderRoute: typeof AppSettingsIntegrationsClaudeConnectorImport
      parentRoute: typeof AppSettingsIntegrationsRouteImport
    }
    '/_app/settings/numbers/$number': {
      id: '/_app/settings/numbers/$number'
      path: '/$number'
      fullPath: '/settings/numbers/$number'
      preLoaderRoute: typeof AppSettingsNumbersNumberImport
      parentRoute: typeof AppSettingsNumbersRouteImport
    }
    '/_app/settings/billing/': {
      id: '/_app/settings/billing/'
      path: '/'
      fullPath: '/settings/billing/'
      preLoaderRoute: typeof AppSettingsBillingIndexImport
      parentRoute: typeof AppSettingsBillingRouteImport
    }
    '/_app/settings/call-tags/': {
      id: '/_app/settings/call-tags/'
      path: '/call-tags'
      fullPath: '/settings/call-tags'
      preLoaderRoute: typeof AppSettingsCallTagsIndexImport
      parentRoute: typeof AppSettingsRouteImport
    }
    '/_app/settings/compliance/': {
      id: '/_app/settings/compliance/'
      path: '/'
      fullPath: '/settings/compliance/'
      preLoaderRoute: typeof AppSettingsComplianceIndexImport
      parentRoute: typeof AppSettingsComplianceRouteImport
    }
    '/_app/settings/integrations/': {
      id: '/_app/settings/integrations/'
      path: '/'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof AppSettingsIntegrationsIndexImport
      parentRoute: typeof AppSettingsIntegrationsRouteImport
    }
    '/_app/settings/numbers/': {
      id: '/_app/settings/numbers/'
      path: '/'
      fullPath: '/settings/numbers/'
      preLoaderRoute: typeof AppSettingsNumbersIndexImport
      parentRoute: typeof AppSettingsNumbersRouteImport
    }
  }
}

// Create and export the route tree

interface AppInternalRouteRouteChildren {
  AppInternalOauthRoute: typeof AppInternalOauthRoute
  AppInternalUsersRoute: typeof AppInternalUsersRoute
}

const AppInternalRouteRouteChildren: AppInternalRouteRouteChildren = {
  AppInternalOauthRoute: AppInternalOauthRoute,
  AppInternalUsersRoute: AppInternalUsersRoute,
}

const AppInternalRouteRouteWithChildren =
  AppInternalRouteRoute._addFileChildren(AppInternalRouteRouteChildren)

interface AppSettingsBillingRouteRouteChildren {
  AppSettingsBillingIndexRoute: typeof AppSettingsBillingIndexRoute
}

const AppSettingsBillingRouteRouteChildren: AppSettingsBillingRouteRouteChildren =
  {
    AppSettingsBillingIndexRoute: AppSettingsBillingIndexRoute,
  }

const AppSettingsBillingRouteRouteWithChildren =
  AppSettingsBillingRouteRoute._addFileChildren(
    AppSettingsBillingRouteRouteChildren,
  )

interface AppSettingsComplianceRouteRouteChildren {
  AppSettingsComplianceBrandRoute: typeof AppSettingsComplianceBrandRoute
  AppSettingsComplianceCampaignRoute: typeof AppSettingsComplianceCampaignRoute
  AppSettingsComplianceIndexRoute: typeof AppSettingsComplianceIndexRoute
}

const AppSettingsComplianceRouteRouteChildren: AppSettingsComplianceRouteRouteChildren =
  {
    AppSettingsComplianceBrandRoute: AppSettingsComplianceBrandRoute,
    AppSettingsComplianceCampaignRoute: AppSettingsComplianceCampaignRoute,
    AppSettingsComplianceIndexRoute: AppSettingsComplianceIndexRoute,
  }

const AppSettingsComplianceRouteRouteWithChildren =
  AppSettingsComplianceRouteRoute._addFileChildren(
    AppSettingsComplianceRouteRouteChildren,
  )

interface AppSettingsIntegrationsRouteRouteChildren {
  AppSettingsIntegrationsIntegrationNameRoute: typeof AppSettingsIntegrationsIntegrationNameRoute
  AppSettingsIntegrationsClaudeConnectorRoute: typeof AppSettingsIntegrationsClaudeConnectorRoute
  AppSettingsIntegrationsIndexRoute: typeof AppSettingsIntegrationsIndexRoute
}

const AppSettingsIntegrationsRouteRouteChildren: AppSettingsIntegrationsRouteRouteChildren =
  {
    AppSettingsIntegrationsIntegrationNameRoute:
      AppSettingsIntegrationsIntegrationNameRoute,
    AppSettingsIntegrationsClaudeConnectorRoute:
      AppSettingsIntegrationsClaudeConnectorRoute,
    AppSettingsIntegrationsIndexRoute: AppSettingsIntegrationsIndexRoute,
  }

const AppSettingsIntegrationsRouteRouteWithChildren =
  AppSettingsIntegrationsRouteRoute._addFileChildren(
    AppSettingsIntegrationsRouteRouteChildren,
  )

interface AppSettingsNumbersRouteRouteChildren {
  AppSettingsNumbersNumberRoute: typeof AppSettingsNumbersNumberRoute
  AppSettingsNumbersIndexRoute: typeof AppSettingsNumbersIndexRoute
}

const AppSettingsNumbersRouteRouteChildren: AppSettingsNumbersRouteRouteChildren =
  {
    AppSettingsNumbersNumberRoute: AppSettingsNumbersNumberRoute,
    AppSettingsNumbersIndexRoute: AppSettingsNumbersIndexRoute,
  }

const AppSettingsNumbersRouteRouteWithChildren =
  AppSettingsNumbersRouteRoute._addFileChildren(
    AppSettingsNumbersRouteRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsBillingRouteRoute: typeof AppSettingsBillingRouteRouteWithChildren
  AppSettingsComplianceRouteRoute: typeof AppSettingsComplianceRouteRouteWithChildren
  AppSettingsIntegrationsRouteRoute: typeof AppSettingsIntegrationsRouteRouteWithChildren
  AppSettingsNumbersRouteRoute: typeof AppSettingsNumbersRouteRouteWithChildren
  AppSettingsApiRoute: typeof AppSettingsApiRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsTemplatesRoute: typeof AppSettingsTemplatesRoute
  AppSettingsUsageRoute: typeof AppSettingsUsageRoute
  AppSettingsWebhooksRoute: typeof AppSettingsWebhooksRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsCallTagsIndexRoute: typeof AppSettingsCallTagsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsBillingRouteRoute: AppSettingsBillingRouteRouteWithChildren,
  AppSettingsComplianceRouteRoute: AppSettingsComplianceRouteRouteWithChildren,
  AppSettingsIntegrationsRouteRoute:
    AppSettingsIntegrationsRouteRouteWithChildren,
  AppSettingsNumbersRouteRoute: AppSettingsNumbersRouteRouteWithChildren,
  AppSettingsApiRoute: AppSettingsApiRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsTemplatesRoute: AppSettingsTemplatesRoute,
  AppSettingsUsageRoute: AppSettingsUsageRoute,
  AppSettingsWebhooksRoute: AppSettingsWebhooksRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsCallTagsIndexRoute: AppSettingsCallTagsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppPowerDialerRouteChildren {
  AppPowerDialerIndexRoute: typeof AppPowerDialerIndexRoute
  AppPowerDialerSessionSessionIdRoute: typeof AppPowerDialerSessionSessionIdRoute
}

const AppPowerDialerRouteChildren: AppPowerDialerRouteChildren = {
  AppPowerDialerIndexRoute: AppPowerDialerIndexRoute,
  AppPowerDialerSessionSessionIdRoute: AppPowerDialerSessionSessionIdRoute,
}

const AppPowerDialerRouteWithChildren = AppPowerDialerRoute._addFileChildren(
  AppPowerDialerRouteChildren,
)

interface AppRouteRouteChildren {
  AppInternalRouteRoute: typeof AppInternalRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppCallsRoute: typeof AppCallsRoute
  AppCompaniesRoute: typeof AppCompaniesRoute
  AppContactsRoute: typeof AppContactsRoute
  AppPowerDialerRoute: typeof AppPowerDialerRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCallFlowNumberRoute: typeof AppCallFlowNumberRoute
  AppCallNumberRoute: typeof AppCallNumberRoute
  AppContactContactIdRoute: typeof AppContactContactIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppInternalRouteRoute: AppInternalRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppCallsRoute: AppCallsRoute,
  AppCompaniesRoute: AppCompaniesRoute,
  AppContactsRoute: AppContactsRoute,
  AppPowerDialerRoute: AppPowerDialerRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCallFlowNumberRoute: AppCallFlowNumberRoute,
  AppCallNumberRoute: AppCallNumberRoute,
  AppContactContactIdRoute: AppContactContactIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface DesktopRouteRouteChildren {
  DesktopIncomingCallRoute: typeof DesktopIncomingCallRoute
  DesktopPipCallRoute: typeof DesktopPipCallRoute
}

const DesktopRouteRouteChildren: DesktopRouteRouteChildren = {
  DesktopIncomingCallRoute: DesktopIncomingCallRoute,
  DesktopPipCallRoute: DesktopPipCallRoute,
}

const DesktopRouteRouteWithChildren = DesktopRouteRoute._addFileChildren(
  DesktopRouteRouteChildren,
)

interface LoginRouteRouteChildren {
  LoginOnboardingRoute: typeof LoginOnboardingRoute
  LoginOtpCodeRoute: typeof LoginOtpCodeRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginOnboardingRoute: LoginOnboardingRoute,
  LoginOtpCodeRoute: LoginOtpCodeRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AppRouteRouteWithChildren
  '/desktop': typeof DesktopRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/logout': typeof LogoutRouteRoute
  '/impersonate': typeof ImpersonateRoute
  '/integrations-callback': typeof IntegrationsCallbackRoute
  '/internal': typeof AppInternalRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/choose-number': typeof onboardingChooseNumberRoute
  '/invite-team': typeof onboardingInviteTeamRoute
  '/analytics': typeof AppAnalyticsRoute
  '/calls': typeof AppCallsRoute
  '/companies': typeof AppCompaniesRoute
  '/contacts': typeof AppContactsRoute
  '/power-dialer': typeof AppPowerDialerRouteWithChildren
  '/desktop/incoming-call': typeof DesktopIncomingCallRoute
  '/desktop/pip-call': typeof DesktopPipCallRoute
  '/jobber/connected': typeof JobberConnectedRoute
  '/login/onboarding': typeof LoginOnboardingRoute
  '/login/otp-code': typeof LoginOtpCodeRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$shareToken': typeof ShareShareTokenRoute
  '/summary/$callId': typeof SummaryCallIdRoute
  '/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/settings/billing': typeof AppSettingsBillingRouteRouteWithChildren
  '/settings/compliance': typeof AppSettingsComplianceRouteRouteWithChildren
  '/settings/integrations': typeof AppSettingsIntegrationsRouteRouteWithChildren
  '/settings/numbers': typeof AppSettingsNumbersRouteRouteWithChildren
  '/call-flow/$number': typeof AppCallFlowNumberRoute
  '/call/$number': typeof AppCallNumberRoute
  '/contact/$contactId': typeof AppContactContactIdRoute
  '/internal/oauth': typeof AppInternalOauthRoute
  '/internal/users': typeof AppInternalUsersRoute
  '/settings/api': typeof AppSettingsApiRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/settings/usage': typeof AppSettingsUsageRoute
  '/settings/webhooks': typeof AppSettingsWebhooksRoute
  '/power-dialer/': typeof AppPowerDialerIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/power-dialer/session/$sessionId': typeof AppPowerDialerSessionSessionIdRoute
  '/settings/compliance/brand': typeof AppSettingsComplianceBrandRoute
  '/settings/compliance/campaign': typeof AppSettingsComplianceCampaignRoute
  '/settings/integrations/$integrationName': typeof AppSettingsIntegrationsIntegrationNameRoute
  '/settings/integrations/claude-connector': typeof AppSettingsIntegrationsClaudeConnectorRoute
  '/settings/numbers/$number': typeof AppSettingsNumbersNumberRoute
  '/settings/billing/': typeof AppSettingsBillingIndexRoute
  '/settings/call-tags': typeof AppSettingsCallTagsIndexRoute
  '/settings/compliance/': typeof AppSettingsComplianceIndexRoute
  '/settings/integrations/': typeof AppSettingsIntegrationsIndexRoute
  '/settings/numbers/': typeof AppSettingsNumbersIndexRoute
}

export interface FileRoutesByTo {
  '/desktop': typeof DesktopRouteRouteWithChildren
  '/logout': typeof LogoutRouteRoute
  '/impersonate': typeof ImpersonateRoute
  '/integrations-callback': typeof IntegrationsCallbackRoute
  '/internal': typeof AppInternalRouteRouteWithChildren
  '/choose-number': typeof onboardingChooseNumberRoute
  '/invite-team': typeof onboardingInviteTeamRoute
  '/analytics': typeof AppAnalyticsRoute
  '/calls': typeof AppCallsRoute
  '/companies': typeof AppCompaniesRoute
  '/contacts': typeof AppContactsRoute
  '/desktop/incoming-call': typeof DesktopIncomingCallRoute
  '/desktop/pip-call': typeof DesktopPipCallRoute
  '/jobber/connected': typeof JobberConnectedRoute
  '/login/onboarding': typeof LoginOnboardingRoute
  '/login/otp-code': typeof LoginOtpCodeRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$shareToken': typeof ShareShareTokenRoute
  '/summary/$callId': typeof SummaryCallIdRoute
  '/': typeof AppIndexRoute
  '/login': typeof LoginIndexRoute
  '/call-flow/$number': typeof AppCallFlowNumberRoute
  '/call/$number': typeof AppCallNumberRoute
  '/contact/$contactId': typeof AppContactContactIdRoute
  '/internal/oauth': typeof AppInternalOauthRoute
  '/internal/users': typeof AppInternalUsersRoute
  '/settings/api': typeof AppSettingsApiRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/settings/usage': typeof AppSettingsUsageRoute
  '/settings/webhooks': typeof AppSettingsWebhooksRoute
  '/power-dialer': typeof AppPowerDialerIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/power-dialer/session/$sessionId': typeof AppPowerDialerSessionSessionIdRoute
  '/settings/compliance/brand': typeof AppSettingsComplianceBrandRoute
  '/settings/compliance/campaign': typeof AppSettingsComplianceCampaignRoute
  '/settings/integrations/$integrationName': typeof AppSettingsIntegrationsIntegrationNameRoute
  '/settings/integrations/claude-connector': typeof AppSettingsIntegrationsClaudeConnectorRoute
  '/settings/numbers/$number': typeof AppSettingsNumbersNumberRoute
  '/settings/billing': typeof AppSettingsBillingIndexRoute
  '/settings/call-tags': typeof AppSettingsCallTagsIndexRoute
  '/settings/compliance': typeof AppSettingsComplianceIndexRoute
  '/settings/integrations': typeof AppSettingsIntegrationsIndexRoute
  '/settings/numbers': typeof AppSettingsNumbersIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/desktop': typeof DesktopRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/logout': typeof LogoutRouteRoute
  '/impersonate': typeof ImpersonateRoute
  '/integrations-callback': typeof IntegrationsCallbackRoute
  '/_app/internal': typeof AppInternalRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/(onboarding)/choose-number': typeof onboardingChooseNumberRoute
  '/(onboarding)/invite-team': typeof onboardingInviteTeamRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/calls': typeof AppCallsRoute
  '/_app/companies': typeof AppCompaniesRoute
  '/_app/contacts': typeof AppContactsRoute
  '/_app/power-dialer': typeof AppPowerDialerRouteWithChildren
  '/desktop/incoming-call': typeof DesktopIncomingCallRoute
  '/desktop/pip-call': typeof DesktopPipCallRoute
  '/jobber/connected': typeof JobberConnectedRoute
  '/login/onboarding': typeof LoginOnboardingRoute
  '/login/otp-code': typeof LoginOtpCodeRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/share/$shareToken': typeof ShareShareTokenRoute
  '/summary/$callId': typeof SummaryCallIdRoute
  '/_app/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_app/settings/billing': typeof AppSettingsBillingRouteRouteWithChildren
  '/_app/settings/compliance': typeof AppSettingsComplianceRouteRouteWithChildren
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRouteRouteWithChildren
  '/_app/settings/numbers': typeof AppSettingsNumbersRouteRouteWithChildren
  '/_app/call-flow/$number': typeof AppCallFlowNumberRoute
  '/_app/call/$number': typeof AppCallNumberRoute
  '/_app/contact/$contactId': typeof AppContactContactIdRoute
  '/_app/internal/oauth': typeof AppInternalOauthRoute
  '/_app/internal/users': typeof AppInternalUsersRoute
  '/_app/settings/api': typeof AppSettingsApiRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/settings/templates': typeof AppSettingsTemplatesRoute
  '/_app/settings/usage': typeof AppSettingsUsageRoute
  '/_app/settings/webhooks': typeof AppSettingsWebhooksRoute
  '/_app/power-dialer/': typeof AppPowerDialerIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/power-dialer/session/$sessionId': typeof AppPowerDialerSessionSessionIdRoute
  '/_app/settings/compliance/brand': typeof AppSettingsComplianceBrandRoute
  '/_app/settings/compliance/campaign': typeof AppSettingsComplianceCampaignRoute
  '/_app/settings/integrations/$integrationName': typeof AppSettingsIntegrationsIntegrationNameRoute
  '/_app/settings/integrations/claude-connector': typeof AppSettingsIntegrationsClaudeConnectorRoute
  '/_app/settings/numbers/$number': typeof AppSettingsNumbersNumberRoute
  '/_app/settings/billing/': typeof AppSettingsBillingIndexRoute
  '/_app/settings/call-tags/': typeof AppSettingsCallTagsIndexRoute
  '/_app/settings/compliance/': typeof AppSettingsComplianceIndexRoute
  '/_app/settings/integrations/': typeof AppSettingsIntegrationsIndexRoute
  '/_app/settings/numbers/': typeof AppSettingsNumbersIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/desktop'
    | '/login'
    | '/logout'
    | '/impersonate'
    | '/integrations-callback'
    | '/internal'
    | '/settings'
    | '/choose-number'
    | '/invite-team'
    | '/analytics'
    | '/calls'
    | '/companies'
    | '/contacts'
    | '/power-dialer'
    | '/desktop/incoming-call'
    | '/desktop/pip-call'
    | '/jobber/connected'
    | '/login/onboarding'
    | '/login/otp-code'
    | '/oauth/consent'
    | '/share/$shareToken'
    | '/summary/$callId'
    | '/'
    | '/login/'
    | '/settings/billing'
    | '/settings/compliance'
    | '/settings/integrations'
    | '/settings/numbers'
    | '/call-flow/$number'
    | '/call/$number'
    | '/contact/$contactId'
    | '/internal/oauth'
    | '/internal/users'
    | '/settings/api'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/templates'
    | '/settings/usage'
    | '/settings/webhooks'
    | '/power-dialer/'
    | '/settings/'
    | '/power-dialer/session/$sessionId'
    | '/settings/compliance/brand'
    | '/settings/compliance/campaign'
    | '/settings/integrations/$integrationName'
    | '/settings/integrations/claude-connector'
    | '/settings/numbers/$number'
    | '/settings/billing/'
    | '/settings/call-tags'
    | '/settings/compliance/'
    | '/settings/integrations/'
    | '/settings/numbers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/desktop'
    | '/logout'
    | '/impersonate'
    | '/integrations-callback'
    | '/internal'
    | '/choose-number'
    | '/invite-team'
    | '/analytics'
    | '/calls'
    | '/companies'
    | '/contacts'
    | '/desktop/incoming-call'
    | '/desktop/pip-call'
    | '/jobber/connected'
    | '/login/onboarding'
    | '/login/otp-code'
    | '/oauth/consent'
    | '/share/$shareToken'
    | '/summary/$callId'
    | '/'
    | '/login'
    | '/call-flow/$number'
    | '/call/$number'
    | '/contact/$contactId'
    | '/internal/oauth'
    | '/internal/users'
    | '/settings/api'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/templates'
    | '/settings/usage'
    | '/settings/webhooks'
    | '/power-dialer'
    | '/settings'
    | '/power-dialer/session/$sessionId'
    | '/settings/compliance/brand'
    | '/settings/compliance/campaign'
    | '/settings/integrations/$integrationName'
    | '/settings/integrations/claude-connector'
    | '/settings/numbers/$number'
    | '/settings/billing'
    | '/settings/call-tags'
    | '/settings/compliance'
    | '/settings/integrations'
    | '/settings/numbers'
  id:
    | '__root__'
    | '/_app'
    | '/desktop'
    | '/login'
    | '/logout'
    | '/impersonate'
    | '/integrations-callback'
    | '/_app/internal'
    | '/_app/settings'
    | '/(onboarding)/choose-number'
    | '/(onboarding)/invite-team'
    | '/_app/analytics'
    | '/_app/calls'
    | '/_app/companies'
    | '/_app/contacts'
    | '/_app/power-dialer'
    | '/desktop/incoming-call'
    | '/desktop/pip-call'
    | '/jobber/connected'
    | '/login/onboarding'
    | '/login/otp-code'
    | '/oauth/consent'
    | '/share/$shareToken'
    | '/summary/$callId'
    | '/_app/'
    | '/login/'
    | '/_app/settings/billing'
    | '/_app/settings/compliance'
    | '/_app/settings/integrations'
    | '/_app/settings/numbers'
    | '/_app/call-flow/$number'
    | '/_app/call/$number'
    | '/_app/contact/$contactId'
    | '/_app/internal/oauth'
    | '/_app/internal/users'
    | '/_app/settings/api'
    | '/_app/settings/profile'
    | '/_app/settings/team'
    | '/_app/settings/templates'
    | '/_app/settings/usage'
    | '/_app/settings/webhooks'
    | '/_app/power-dialer/'
    | '/_app/settings/'
    | '/_app/power-dialer/session/$sessionId'
    | '/_app/settings/compliance/brand'
    | '/_app/settings/compliance/campaign'
    | '/_app/settings/integrations/$integrationName'
    | '/_app/settings/integrations/claude-connector'
    | '/_app/settings/numbers/$number'
    | '/_app/settings/billing/'
    | '/_app/settings/call-tags/'
    | '/_app/settings/compliance/'
    | '/_app/settings/integrations/'
    | '/_app/settings/numbers/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  DesktopRouteRoute: typeof DesktopRouteRouteWithChildren
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
  LogoutRouteRoute: typeof LogoutRouteRoute
  ImpersonateRoute: typeof ImpersonateRoute
  IntegrationsCallbackRoute: typeof IntegrationsCallbackRoute
  onboardingChooseNumberRoute: typeof onboardingChooseNumberRoute
  onboardingInviteTeamRoute: typeof onboardingInviteTeamRoute
  JobberConnectedRoute: typeof JobberConnectedRoute
  OauthConsentRoute: typeof OauthConsentRoute
  ShareShareTokenRoute: typeof ShareShareTokenRoute
  SummaryCallIdRoute: typeof SummaryCallIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  DesktopRouteRoute: DesktopRouteRouteWithChildren,
  LoginRouteRoute: LoginRouteRouteWithChildren,
  LogoutRouteRoute: LogoutRouteRoute,
  ImpersonateRoute: ImpersonateRoute,
  IntegrationsCallbackRoute: IntegrationsCallbackRoute,
  onboardingChooseNumberRoute: onboardingChooseNumberRoute,
  onboardingInviteTeamRoute: onboardingInviteTeamRoute,
  JobberConnectedRoute: JobberConnectedRoute,
  OauthConsentRoute: OauthConsentRoute,
  ShareShareTokenRoute: ShareShareTokenRoute,
  SummaryCallIdRoute: SummaryCallIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/desktop",
        "/login",
        "/logout",
        "/impersonate",
        "/integrations-callback",
        "/(onboarding)/choose-number",
        "/(onboarding)/invite-team",
        "/jobber/connected",
        "/oauth/consent",
        "/share/$shareToken",
        "/summary/$callId"
      ]
    },
    "/_app": {
      "filePath": "_app/route.tsx",
      "children": [
        "/_app/internal",
        "/_app/settings",
        "/_app/analytics",
        "/_app/calls",
        "/_app/companies",
        "/_app/contacts",
        "/_app/power-dialer",
        "/_app/",
        "/_app/call-flow/$number",
        "/_app/call/$number",
        "/_app/contact/$contactId"
      ]
    },
    "/desktop": {
      "filePath": "desktop/route.tsx",
      "children": [
        "/desktop/incoming-call",
        "/desktop/pip-call"
      ]
    },
    "/login": {
      "filePath": "login/route.tsx",
      "children": [
        "/login/onboarding",
        "/login/otp-code",
        "/login/"
      ]
    },
    "/logout": {
      "filePath": "logout/route.tsx"
    },
    "/impersonate": {
      "filePath": "impersonate.tsx"
    },
    "/integrations-callback": {
      "filePath": "integrations-callback.tsx"
    },
    "/_app/internal": {
      "filePath": "_app/internal/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/internal/oauth",
        "/_app/internal/users"
      ]
    },
    "/_app/settings": {
      "filePath": "_app/settings/route.tsx",
      "parent": "/_app",
      "children": [
        "/_app/settings/billing",
        "/_app/settings/compliance",
        "/_app/settings/integrations",
        "/_app/settings/numbers",
        "/_app/settings/api",
        "/_app/settings/profile",
        "/_app/settings/team",
        "/_app/settings/templates",
        "/_app/settings/usage",
        "/_app/settings/webhooks",
        "/_app/settings/",
        "/_app/settings/call-tags/"
      ]
    },
    "/(onboarding)/choose-number": {
      "filePath": "(onboarding)/choose-number.tsx"
    },
    "/(onboarding)/invite-team": {
      "filePath": "(onboarding)/invite-team.tsx"
    },
    "/_app/analytics": {
      "filePath": "_app/analytics.tsx",
      "parent": "/_app"
    },
    "/_app/calls": {
      "filePath": "_app/calls.tsx",
      "parent": "/_app"
    },
    "/_app/companies": {
      "filePath": "_app/companies.tsx",
      "parent": "/_app"
    },
    "/_app/contacts": {
      "filePath": "_app/contacts.tsx",
      "parent": "/_app"
    },
    "/_app/power-dialer": {
      "filePath": "_app/power-dialer.tsx",
      "parent": "/_app",
      "children": [
        "/_app/power-dialer/",
        "/_app/power-dialer/session/$sessionId"
      ]
    },
    "/desktop/incoming-call": {
      "filePath": "desktop/incoming-call.tsx",
      "parent": "/desktop"
    },
    "/desktop/pip-call": {
      "filePath": "desktop/pip-call.tsx",
      "parent": "/desktop"
    },
    "/jobber/connected": {
      "filePath": "jobber/connected.tsx"
    },
    "/login/onboarding": {
      "filePath": "login/onboarding.tsx",
      "parent": "/login"
    },
    "/login/otp-code": {
      "filePath": "login/otp-code.tsx",
      "parent": "/login"
    },
    "/oauth/consent": {
      "filePath": "oauth/consent.tsx"
    },
    "/share/$shareToken": {
      "filePath": "share.$shareToken.tsx"
    },
    "/summary/$callId": {
      "filePath": "summary.$callId.tsx"
    },
    "/_app/": {
      "filePath": "_app/index.tsx",
      "parent": "/_app"
    },
    "/login/": {
      "filePath": "login/index.tsx",
      "parent": "/login"
    },
    "/_app/settings/billing": {
      "filePath": "_app/settings/billing/route.tsx",
      "parent": "/_app/settings",
      "children": [
        "/_app/settings/billing/"
      ]
    },
    "/_app/settings/compliance": {
      "filePath": "_app/settings/compliance/route.tsx",
      "parent": "/_app/settings",
      "children": [
        "/_app/settings/compliance/brand",
        "/_app/settings/compliance/campaign",
        "/_app/settings/compliance/"
      ]
    },
    "/_app/settings/integrations": {
      "filePath": "_app/settings/integrations/route.tsx",
      "parent": "/_app/settings",
      "children": [
        "/_app/settings/integrations/$integrationName",
        "/_app/settings/integrations/claude-connector",
        "/_app/settings/integrations/"
      ]
    },
    "/_app/settings/numbers": {
      "filePath": "_app/settings/numbers/route.tsx",
      "parent": "/_app/settings",
      "children": [
        "/_app/settings/numbers/$number",
        "/_app/settings/numbers/"
      ]
    },
    "/_app/call-flow/$number": {
      "filePath": "_app/call-flow.$number.tsx",
      "parent": "/_app"
    },
    "/_app/call/$number": {
      "filePath": "_app/call.$number.tsx",
      "parent": "/_app"
    },
    "/_app/contact/$contactId": {
      "filePath": "_app/contact.$contactId.tsx",
      "parent": "/_app"
    },
    "/_app/internal/oauth": {
      "filePath": "_app/internal/oauth.tsx",
      "parent": "/_app/internal"
    },
    "/_app/internal/users": {
      "filePath": "_app/internal/users.tsx",
      "parent": "/_app/internal"
    },
    "/_app/settings/api": {
      "filePath": "_app/settings/api.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/profile": {
      "filePath": "_app/settings/profile.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/team": {
      "filePath": "_app/settings/team.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/templates": {
      "filePath": "_app/settings/templates.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/usage": {
      "filePath": "_app/settings/usage.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/webhooks": {
      "filePath": "_app/settings/webhooks.tsx",
      "parent": "/_app/settings"
    },
    "/_app/power-dialer/": {
      "filePath": "_app/power-dialer.index.tsx",
      "parent": "/_app/power-dialer"
    },
    "/_app/settings/": {
      "filePath": "_app/settings/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/power-dialer/session/$sessionId": {
      "filePath": "_app/power-dialer.session.$sessionId.tsx",
      "parent": "/_app/power-dialer"
    },
    "/_app/settings/compliance/brand": {
      "filePath": "_app/settings/compliance/brand.tsx",
      "parent": "/_app/settings/compliance"
    },
    "/_app/settings/compliance/campaign": {
      "filePath": "_app/settings/compliance/campaign.tsx",
      "parent": "/_app/settings/compliance"
    },
    "/_app/settings/integrations/$integrationName": {
      "filePath": "_app/settings/integrations/$integrationName.tsx",
      "parent": "/_app/settings/integrations"
    },
    "/_app/settings/integrations/claude-connector": {
      "filePath": "_app/settings/integrations/claude-connector.tsx",
      "parent": "/_app/settings/integrations"
    },
    "/_app/settings/numbers/$number": {
      "filePath": "_app/settings/numbers/$number.tsx",
      "parent": "/_app/settings/numbers"
    },
    "/_app/settings/billing/": {
      "filePath": "_app/settings/billing/index.tsx",
      "parent": "/_app/settings/billing"
    },
    "/_app/settings/call-tags/": {
      "filePath": "_app/settings/call-tags/index.tsx",
      "parent": "/_app/settings"
    },
    "/_app/settings/compliance/": {
      "filePath": "_app/settings/compliance/index.tsx",
      "parent": "/_app/settings/compliance"
    },
    "/_app/settings/integrations/": {
      "filePath": "_app/settings/integrations/index.tsx",
      "parent": "/_app/settings/integrations"
    },
    "/_app/settings/numbers/": {
      "filePath": "_app/settings/numbers/index.tsx",
      "parent": "/_app/settings/numbers"
    }
  }
}
ROUTE_MANIFEST_END */
